import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const jaTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: '名前 (小文字、特殊文字なし)',
    add: '追加',
    allowedFileTypes: '許可されるファイルの種類',
    allowedFileTypesDescription:
      '許可されるファイルの種類を制限します (例: image/*、application/pdf)。すべてのタイプを許可するには、空のままにします。',
    allowMultipleFiles: '複数のファイルを許可する',
    amountInCents: 'セント単位の金額',
    basePrice: '基本価格',
    bcc: 'BCC',
    brand: 'ブランド',
    cc: 'CC',
    checkboxPlural: 'チェックボックスフィールド',
    checkboxSingular: 'チェックボックス',
    checkedByDefault: 'デフォルトでチェックされています',
    chooseConfirmationType:
      'フォームの送信後にページ上にメッセージを表示するか、別のページにリダイレクトするかを選択します。',
    condition: '状態',
    confirmationMessage: '確認メッセージ',
    confirmationType: '確認タイプ',
    countryPlural: '国のフィールド',
    countrySingular: '国',
    creditCard: 'クレジットカード',
    customURL: 'カスタムURL',
    datePlural: '日付フィールド',
    dateSingular: '日付',
    defaultValue: 'デフォルト値',
    divide: '分ける',
    documentToLinkTo: 'リンク先のドキュメント',
    doesNotEqual: '等しくない',
    emailFrom: 'メール送信元',
    emailPlural: '電子メールフィールド',
    emailsDescription:
      'フォームの送信時にカスタム電子メールを送信します。同じ電子メールを複数の受信者に送信するには、カンマ区切りのリストを使用します。このフォームから値を参照するには、そのフィールドの名前を二重中括弧で囲みます (例: {{firstName}})。ワイルドカード {{*}} を使用してすべてのデータを出力し、{{*:table}} を使用してメール内の HTML テーブルとしてフォーマットすることができます。',
    emailSingular: '電子メール',
    emailTo: 'メールアドレス',
    equals: '等しい',
    field: 'フィールド',
    fields: 'フィールド',
    fieldWidth: 'フィールド幅 (パーセンテージ)',
    hasAnyValue: '任意の値を持つ',
    internalLink: '内部リンク',
    label: 'ラベル',
    maxFileSize: '最大ファイルサイズ (バイト)',
    maxFileSizeDescription:
      '最大ファイル サイズ (バイト単位)。制限を設けない場合は空のままにします。',
    message: 'メッセージ',
    messageDescription: 'このメールで送信するメッセージを入力してください。',
    messagePlural: 'メッセージブロック',
    messageSingular: 'メッセージ',
    mimeType: 'MIME タイプ',
    mimeTypePlural: 'MIME タイプ',
    mimeTypeSingular: 'MIME タイプ',
    multiply: '乗算する',
    numberPlural: '数値フィールド',
    numberSingular: '番号',
    optionPlural: 'オプション',
    optionSingular: 'オプション',
    paymentFieldPlural: '支払いフィールド',
    paymentFieldSingular: 'お支払い',
    paymentProcessor: '支払処理業者',
    paymentStatus: 'ステータス',
    placeholder: 'プレースホルダー',
    priceConditions: '価格条件',
    priceConditionsPlural: '価格条件',
    priceConditionsSingular: '価格条件',
    radioOptions: '無線属性のオプション',
    radioPlural: '無線フィールド',
    radioSingular: 'ラジオ',
    redirect: 'リダイレクト',
    replyTo: '返信先',
    required: '必須',
    selectOptions: 'オプションの選択',
    selectPlural: 'フィールドの選択',
    selectSingular: '選択',
    statePlural: '状態フィールド',
    stateSingular: '州',
    staticValue: '静的値',
    subject: '件名',
    submitButton: '送信ボタンのラベル',
    subtract: '減算',
    textareaPlural: 'テキストエリアのフィールド',
    textareaSingular: 'テキストエリア',
    textPlural: 'テキストフィールド',
    textSingular: 'テキスト',
    title: 'タイトル',
    token: 'トークン',
    uploadCollection: 'コレクションをアップロードする',
    uploadCollectionDescription: 'ファイルを保存するアップロード コレクションを選択します',
    uploadFieldPlural: 'アップロードフィールド',
    uploadFieldSingular: 'アップロード',
    urlToRedirectTo: 'リダイレクト先の URL',
    value: '値',
    valueOfField: 'フィールドの値',
    valueType: '値のタイプ',
  },
}

export const ja: PluginLanguage = {
  dateFNSKey: 'ja',
  translations: jaTranslations,
}
